var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyFcWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5983",
    "data-name": "Group 5983",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.252,
    height: 44.252,
    viewBox: "0 0 44.252 44.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5982",
    "data-name": "Group 5982",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5856",
    "data-name": "Group 5856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M0,0V44.252H44.252V22.482H33.468V33.265H10.987V10.784H21.77V0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M18.761,0,35.813,17.052V0Z",
    transform: "translate(7.899 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyFcWhite);
export default __webpack_public_path__ + "static/media/company-fc-white.291651f0dcaa5ef5310eba8fe672986e.svg";
export { ForwardRef as ReactComponent };